export const blockIconsActivitiesNightsStayNew = (
	<span className='material-symbols-outlined'>nights_stay</span>
);
